/**
 * API native (muc 6.2) — gon hon lop tuong thich 2Captcha, cho project viet moi.
 * Chay song song va DUNG CHUNG dispatcher voi lop 2Captcha, khong phai duong rieng.
 */
import { z } from 'zod';
import { NATIVE_TYPES } from './taskTypes.js';
export const CHARSETS = ['numeric', 'alpha', 'alnum', 'any'];
/**
 * Rang buoc dap an. Solver dung chung de HAU XU LY: dap an vi pham rang buoc
 * thi tra null thay vi tra bua — bo loc re tien ma cuc hieu qua (muc 9, solver ocr).
 */
export const ConstraintsSchema = z
    .object({
    minLength: z.number().int().min(1).max(64).optional(),
    maxLength: z.number().int().min(1).max(64).optional(),
    charset: z.enum(CHARSETS).optional(),
    caseSensitive: z.boolean().optional(),
    /** GridTask: so hang / so cot cua luoi. */
    rows: z.number().int().min(1).max(16).optional(),
    columns: z.number().int().min(1).max(16).optional(),
    /** RotateTask: buoc goc hop le (thuong 40 hoac 2 do). */
    angle: z.number().int().min(1).max(180).optional(),
    /** Huong dan bang chu di kem captcha (GridTask/CoordinatesTask). */
    comment: z.string().max(2000).optional(),
})
    .catchall(z.unknown());
export const SolveRequestSchema = z
    .object({
    type: z.enum(NATIVE_TYPES),
    /** base64 tho hoac data URL. Bat buoc voi image/rotate; grid co the dung cells. */
    image: z.string().min(1).optional(),
    /**
     * GridTask: bytes NGUYEN GOC cua tung file anh o, theo thu tu trai->phai,
     * tren->duoi. Server tu bam sha256 va thu duong tra chinh xac truoc pHash.
     *
     * Day la field JSON nen moi phan tu la base64 tho hoac data URL. `image` van nen
     * gui kem neu client muon giu duong fallback pHash/upstream khi mot SHA chua biet.
     */
    cells: z.array(z.string().min(1)).min(1).max(256).optional(),
    /** Cau hoi thuan van ban. Bat buoc voi type text. */
    text: z.string().min(1).optional(),
    /**
     * Bat buoc voi type pow: challenge LAY SAN tu site, truyen nguyen ven vao day.
     *
     * capforge KHONG tu goi endpoint challenge cua site. Muon vay thi server phai phat
     * HTTP ra mot URL do client cung cap — tuc mo mot duong SSRF di thang vao mang noi
     * bo cua nguoi van hanh — doi lay viec tiet kiem cho client dung mot loi goi fetch
     * ma no vua moi thuc hien xong. Doi cho khong dang.
     *
     * Voi Altcha: day chinh la JSON ma `/altcha/challenge` cua site tra ve, gom
     * `algorithm`, `challenge`, `salt`, `maxnumber`, `signature`.
     */
    challenge: z.record(z.string(), z.unknown()).optional(),
    /** Tuy chon voi type pow — chi de khop profile theo host va de tra cuu trong log. */
    websiteURL: z.string().min(1).optional(),
    websiteKey: z.string().min(1).optional(),
    profileKey: z.string().min(1).optional(),
    siteHost: z.string().min(1).optional(),
    constraints: ConstraintsSchema.optional(),
    /** Chi co y nghia voi POST /v1/solve (dong bo). Mac dinh CAPFORGE_SOLVE_TIMEOUT_MS. */
    timeoutMs: z.number().int().min(1000).max(600000).optional(),
    metadata: z.record(z.string(), z.unknown()).optional(),
})
    .catchall(z.unknown());
/**
 * Ly do that bai.
 *
 * Bon gia tri dau la cua dac ta (muc 6.2). Cac gia tri sau la tinh huong van hanh
 * (xac thuc, quota, request sai) — van tra HTTP 200 kem `ok: false` de client chi
 * phai xu ly MOT nhanh loi duy nhat, dung phai phan biet loi mang voi loi nghiep vu.
 */
export const NATIVE_FAIL_REASONS = [
    'no_solver',
    'low_confidence',
    'timeout',
    'upstream_disabled',
    'invalid_request',
    'unsupported_type',
    'unauthorized',
    'rate_limited',
    'quota_exceeded',
    'internal_error',
];
/**
 * BANG CHUNG dung sau mot bao cao.
 *
 * ============================================================================
 *  VI SAO MOT BOOLEAN `correct` LA KHONG DU:
 *
 *  Cung mot chieu bao co the dua tren hai loai bang chung khac han suc nang:
 *
 *    - "site dich TU CHOI captcha nay"           -> bang chung
 *    - "dap an nay khac voi nha cung cap X"      -> Y KIEN cua X
 *
 *  Loai thu hai khong noi len ai dung. Mot nguoi dung do tren du lieu that: trong
 *  nhung lan hai ben lech nhau, 82% la NHA CUNG CAP KIA sai chu khong phai capforge.
 *  Dem chung vao cung mot bo dem voi bang chung that thi mot solver dung 96% se hien
 *  ra la 80%, va ngat mach se tat mot profile dang chay tot.
 *
 *  Nhung bo han loai thu hai cung sai: no van la tin hieu, chi la tin hieu yeu.
 *  Vi vay: ghi lai ca hai, nhung chi loai MANH moi duoc dung ngat mach va cong
 *  thang cap.
 *
 *  Day khong phai khai niem moi trong he thong nay — `Sample.labelSource` da ghi
 *  "nhan nay tu dau ra" tu dau. Truong nay mang dung khai niem do sang cho bao cao.
 * ============================================================================
 */
export const REPORT_EVIDENCE = [
    /** Site dich chap nhan / tu choi captcha. Bang chung that. */
    'site',
    /** Nguoi nhin anh va xac nhan. Bang chung that. */
    'human',
    /** Khac voi mot nha cung cap khac. Y kien, khong phai bang chung. */
    'comparison',
];
/**
 * Loai bang chung KHONG duoc phep tac dong toi ngat mach va cong thang cap.
 *
 * Danh sach dung chieu YEU chu khong phai chieu manh, va do la mot quyet dinh:
 * moi gia tri KHONG NAM trong danh sach nay — ke ca chuoi la, ke ca `null` — deu
 * duoc coi la MANH. Xem `isStrongEvidence`.
 */
const WEAK_EVIDENCE = new Set(['comparison']);
/**
 * Bao cao nay co du suc nang de tat mot profile khong?
 *
 * ============================================================================
 *  MAC DINH LA MANH, va moi truong hop khong ro cung la manh.
 *
 *  Hai ly do khac nhau dan toi cung mot ket luan:
 *
 *  1. `null`/thieu: moi client dang chay hom nay bao cao ket qua submit that ma khong
 *     khai truong nay. Coi mac dinh la yeu se lang le tat ngat mach cua ho dung vao
 *     ngay nang cap — mot thay doi im lang lam GIAM an toan.
 *
 *  2. Chuoi LA (go sai, ban SDK moi hon server, du lieu cu trong DB): neu liet ke
 *     chieu manh thi mot gia tri khong nhan ra se roi vao nhom yeu, tuc lang le vo
 *     hieu hoa ngat mach — dung cai bay o (1), chi khac duong den. Liet ke chieu YEU
 *     thi moi thu khong ro deu nga ve phia an toan.
 *
 *  Ngoai ra no giu `isStrongEvidence` va `effectiveEvidence` NHAT QUAN theo cau truc:
 *  ca hai deu quy gia tri khong nhan ra ve nhom manh, nen gia tri doi lai cho client
 *  khong bao gio noi khac voi quyet dinh that.
 * ============================================================================
 */
export function isStrongEvidence(evidence) {
    return evidence === null || evidence === undefined || !WEAK_EVIDENCE.has(evidence);
}
/**
 * Bang chung THUC SU duoc ap dung cho mot bao cao — de doi lai cho client.
 *
 * Thieu hoac khong hop le deu quy ve `"site"`, dung theo luat cua `isStrongEvidence`.
 * Nho vay gia tri doi lai luon noi that dieu server DA LAM, chu khong phai dieu client
 * xin: gui `"comparison"` ma nhan lai `"site"` nghia la gia tri bi tu choi.
 */
export function effectiveEvidence(evidence) {
    return REPORT_EVIDENCE.includes(evidence ?? '')
        ? evidence
        : 'site';
}
export const JobReportRequestSchema = z
    .object({
    correct: z.boolean(),
    /** Bo trong = "site" (xem `isStrongEvidence`). */
    evidence: z.enum(REPORT_EVIDENCE).optional(),
    /**
     * Chi TRA LOI xem se lam gi, KHONG ghi gi ca. Mac dinh false.
     *
     * ======================================================================
     *  VI SAO CAN, va vi sao bat doi xung neu thieu:
     *
     *  Nhanh `comparison` tu kiem duoc thoai mai — theo dinh nghia no khong quyet
     *  dinh gi, nen bao thu vai lan khong lam ban du lieu.
     *
     *  Nhanh `site`/`human` thi KHONG: kiem no tuc la khang dinh mot dieu minh khong
     *  biet, tren mot task chua he di qua site dich nao. Nghia la dung nhanh QUAN
     *  TRONG NHAT — nhanh nuoi ngat mach va cong thang cap — lai la nhanh khong ai
     *  kiem duoc ma khong bom bao cao gia vao thong ke cua chinh minh.
     *
     *  `dryRun` go bo bat doi xung do: anh xa van duoc noi ra day du (ke ca nhanh gia
     *  tri la), khong bo dem nao bi dung toi. Cung loi nghi voi dry-run mac dinh o
     *  `POST /admin/samples/delete`, chi la mang sang phia client.
     * ======================================================================
     */
    dryRun: z.boolean().optional(),
})
    .catchall(z.unknown());
/**
 * Ten cac tinh nang xuat hien trong `HealthResponse.capabilities`.
 *
 * Chi liet ke nhung tinh nang ma viec BI BO QUA IM LANG lam doi Y NGHIA hanh dong cua
 * client — khong phai moi endpoint. Danh sach nay la hop dong, nen no phai ngan de con
 * dung duoc; them bua bai thi khong ai doc nua.
 */
export const CAPABILITIES = {
    /** `report` doc `evidence` va chi cho bang chung manh nuoi ngat mach/cong thang cap. */
    REPORT_EVIDENCE: 'report.evidence',
    /** `report` doc `dryRun` va KHONG ghi gi khi no bang true. */
    REPORT_DRY_RUN: 'report.dryRun',
    /** GridTask doc `cells[]`, tu bam bytes goc va tra SHA-256 chinh xac truoc pHash. */
    HASHGRID_CELLS_SHA256: 'hashgrid.cellsSha256',
};
/** Moi tinh nang ban capforge nay ho tro. Server dat thang vao `/v1/health`. */
export const ALL_CAPABILITIES = Object.values(CAPABILITIES);
//# sourceMappingURL=native.js.map